<template>
	<div class="v-data-table-header__content">
		<v-tooltip v-if="tooltip" location="top" max-width="320" :text="tooltip">
			<template #activator="{ props: activator }">
				<span v-bind="activator" class="metric-header-label">
					<span
						v-for="line in titleLines"
						:key="line"
						class="d-block text-no-wrap"
					>
						{{ line }}
					</span>
				</span>
			</template>
		</v-tooltip>
		<span v-else>
			<span v-for="line in titleLines" :key="line" class="d-block text-no-wrap">
				{{ line }}
			</span>
		</span>
		<v-icon
			v-if="column.sortable"
			class="v-data-table-header__sort-icon"
			:icon="getSortIcon(column)"
		/>
	</div>
</template>

<script>
// Header cell for the activity metrics tables: the default Vuetify header
// content (title + sort icon; the th itself keeps the sort click handler)
// plus a concise tooltip explaining what the column measures.
export default {
	name: "MetricHeader",

	props: {
		column: {
			type: Object,
			required: true,
		},
		tooltip: {
			type: String,
			default: "",
		},
		getSortIcon: {
			type: Function,
			required: true,
		},
	},

	computed: {
		// Headers are the width drivers on these dense tables, so every
		// multi-word title breaks onto two tidy lines. Ratio titles
		// ("Seconds / graph point") break after the slash; the rest break at
		// the space that best balances the two lines (keeps "Avg orientation
		// (s)" from claiming a full single-line column width). Single-word
		// titles stay as they are.
		titleLines() {
			const title = this.column.title || "";
			const slashAt = title.indexOf(" / ");
			if (slashAt !== -1) {
				return [title.slice(0, slashAt + 2), title.slice(slashAt + 3)];
			}
			let best = null;
			for (
				let i = title.indexOf(" ");
				i !== -1;
				i = title.indexOf(" ", i + 1)
			) {
				const longer = Math.max(i, title.length - i - 1);
				if (!best || longer < best.longer) {
					best = { at: i, longer };
				}
			}
			if (!best) {
				return [title];
			}
			return [title.slice(0, best.at), title.slice(best.at + 1)];
		},
	},
};
</script>

<style scoped>
.metric-header-label {
	cursor: help;
	text-decoration: underline dotted;
	text-underline-offset: 3px;
}
</style>
